import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, Injector, NgModule } from "@angular/core";
import { createCustomElement } from "@angular/elements";
import { FormsModule } from "@angular/forms";
import { CarouselModule } from "@vattenfall/ui";

import { CarouselElementSlideElement } from "./carousel-element-slide/carousel-element-slide.component";
import { CarouselElement } from "./carousel-element.component";

@NgModule({
  declarations: [CarouselElement, CarouselElementSlideElement],
  imports: [CommonModule, CarouselModule, FormsModule],
  exports: [CarouselElement, CarouselElementSlideElement],
  bootstrap: [CarouselElement],
})
export class CarouselElementModule {
  constructor(injector: Injector, componentFactoryResolver: ComponentFactoryResolver) {
    if (!customElements.get(componentFactoryResolver.resolveComponentFactory(CarouselElementSlideElement).selector))
      customElements.define(
        componentFactoryResolver.resolveComponentFactory(CarouselElementSlideElement).selector,
        createCustomElement(CarouselElementSlideElement, { injector })
      );
  }
}
